// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29jr3","question":"styles_question__1Zpbt","description":"styles_description__1tTfU"};